<template>
  <div class="d-flex" style="height: 100%; align-items: flex-start;">

    <div
      style="width: 280px; position: sticky; top: 0; height: 100vh; overflow-y: auto; border-right: 1px solid #e0e0e0; background: white; display: flex; flex-direction: column;">
      <v-overlay absolute :value="loadingHistory">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
      </v-overlay>

      <div class="pa-2">
        <v-text-field v-model="searchHistory" label="Search chats..." dense outlined hide-details
          prepend-inner-icon="mdi-magnify" clearable></v-text-field>
      </div>

      <v-list dense class="flex-grow-1" style="overflow-y: auto;">
        <v-list-item @click="onClear" class="mb-2">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">New Chat</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item-group v-model="selectedQuery" color="primary">
          <v-list-item v-for="item in filteredHistory" :key="item.id" @click="onQuerySelect(item)">
            <v-list-item-content>
              <div v-if="item.created" class="created-date">{{ formattedTimestamp(item.created) }}</div>
              <div class="menu-item-text">{{ item.ai_response_title || item.user_query }}</div>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>

    <div class="flex-grow-1" style="height: 100vh;">

      <div v-if="selectedQueryMessages.length === 0"
        style="display: flex; align-items: center; justify-content: center; height: 100%;">
        <div class="chat-inner-wrapper" style="width: 100%;">
          <v-card flat tile>
            <v-card-title class="d-flex justify-center" :style="'word-break: break-word'">Hello {{ $auth.user.given_name
            }}. What would you like to find?</v-card-title>
          </v-card>
          <v-textarea v-model="user_query" outlined flat hide-details :style="'position: relative;'"
            label="Describe the type of notices you are looking for" prepend-inner-icon="mdi-creation"
            class="ma-0 pa-0 font-weight-regular" @keypress.enter.prevent="plainTextSearch(false)" auto-grow @input="onInput"
            :loading="loading_query">
            <template v-slot:loader>
              <v-progress-linear v-if="loading_query" color="primary" height="7" indeterminate></v-progress-linear>
            </template>
            <template v-slot:append>
              <v-btn icon color="primary" @click="plainTextSearch(false)" :disabled="loading_query || !user_query"
                style="position: absolute; bottom: 8px; right: 8px;">
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </template>
          </v-textarea>
        </div>
      </div>

      <div v-else style="display: grid; grid-template-rows: 1fr auto; height: 100%; overflow: hidden;">
        <div style="overflow-y: auto;" ref="chatContainer">
          <div class="chat-inner-wrapper pt-4 pb-4">
            <div v-for="(message, index) in selectedQueryMessages" :key="message.id" class="chat-bubble-container">
              <div class="chat-bubble user-message" v-if="message.message_text">
                <div class="created-date">{{ formattedTimestamp(message.created) }}</div>
                <div class="message-text">{{ message.message_text }}</div>
              </div>
              <div class="chat-bubble system-message" v-if="message.system_response">
                <div class="created-date">{{ formattedTimestamp(message.created) }}</div>
                <div class="message-text" v-html="message.system_response"></div>
                <span>
                  <v-menu offset-y v-if="(!message.errored && !message.is_help && message.querystring)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mt-2 mb-2 mr-3" small color="primary" v-bind="attrs" v-on="on">
                        View Data<v-icon right>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="viewQueryResults(message.querystring, 0)">
                        <v-list-item-title class="text-left">All Results</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="viewQueryResults(message.querystring, 1)">
                        <v-list-item-title class="text-left">Leaderboard</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="viewQueryResults(message.querystring, 2)">
                        <v-list-item-title class="text-left">Entity Network</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="viewQueryResults(message.querystring, 3)">
                        <v-list-item-title class="text-left">Spend Insights</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </span>
                <span>
                  <v-btn v-if="(!message.errored && !message.is_help && message.qry_description)" 
                                class="mr-3 mt-2 mb-2" 
                                small color="primary" 
                                @click="query_description=message.qry_description, show_qry=!show_qry">
                    View Query<v-icon outlined right>mdi-information</v-icon>
                  </v-btn>
                </span>
                <span>
                  <v-btn v-if="(!message.errored && !message.is_help && message.qry_description)" 
                                class="mt-2 mb-2" 
                                small color="primary" 
                                :loading="analysisLoading === index"
                                @click="analyseResults(index)">
                    Analyse<v-icon outlined right>mdi-creation</v-icon>
                  </v-btn>
                </span>
              </div>
            </div>
            <div id="wave" v-if="this.loading_query">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          </div>
        </div>
        <div class="pa-4">
          <div class="chat-inner-wrapper">
            <v-textarea v-model="user_query" outlined flat hide-details :style="'position: relative;'"
              label="Describe the type of notices you are looking for" prepend-inner-icon="mdi-creation"
              class="mx-0 mt-0 mb-5 pa-0 font-weight-regular" @keypress.enter.prevent="plainTextSearch(false)" auto-grow
              @input="onInput" :loading="loading_query">
              <template v-slot:loader>
                <v-progress-linear v-if="loading_query" color="primary" height="7" indeterminate></v-progress-linear>
              </template>
              <template v-slot:append>
                <v-btn icon color="primary" @click="plainTextSearch(false)" :disabled="loading_query || !user_query"
                  style="position: absolute; bottom: 8px; right: 8px;">
                  <v-icon>mdi-send</v-icon>
                </v-btn>
              </template>
            </v-textarea>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="show_qry" hide-overlay width="700" absolute>
        <v-card tile>
        <v-card-title>Auto-generated Search Query
            <div class="flex-grow-1"></div> <v-btn icon @click="show_qry=!show_qry"><v-icon style="font-weight:thin;" medium>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
                <span>{{ query_description }}</span>
        </v-card-text>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { fetchAIQueries, fetchSearchQuery } from "./APIManager.js";

export default {
  props: {
    reset: Number,
    searchParamsQry: String,
    isFullScreen: Boolean
  },
  data() {
    return {
      show_qry:false,
      query_description: "",
      searchHistory: '', // For the new search bar
      user_query: "",
      query_id: null,
      querystring: null,
      selectedQuery: null,
      selectedQueryMessages: [],
      userHistory: [],
      chatHistory: [],
      loadingHistory: false,
      loading_query: false,
      analysisLoading: null, // Track which message is being analyzed
      refresh_query_history: Number,
    };
  },
  computed: {
    // New computed property to filter history based on search input
    filteredHistory() {
      if (!this.searchHistory) {
        return this.userHistory;
      }
      const searchTerm = this.searchHistory.toLowerCase();
      return this.userHistory.filter(item => {
        const title = item.ai_response_title || item.user_query || '';
        return title.toLowerCase().includes(searchTerm);
      });
    }
  },
  watch: {
    reset(val) {
      this.selectedQuery = null;
      this.selectedQueryMessages = [];
      this.query_id = null;
      this.querystring = "";
      this.clearUserQuery();
    },
    $route(to, from) {
      this.querystring = window.location.search;
    },
    selectedQueryMessages() {
      // Call the robust scrollToBottom method whenever messages change
      this.scrollToBottom();
    }
  },
  mounted() {
    //this.querystring = window.location.search;
    this.getAIQueries();
  },
  methods: {
    viewQueryResults(querystring, viewIndex) {
      const query = this.queryStringToJson(querystring);
      query.viewIndex = viewIndex;
      this.$router.push({ path: "/search", query });
    },
    scrollToBottom() {
      // Wait for the DOM to be updated with the new message
      this.$nextTick(() => {
        const container = this.$refs.chatContainer;
        if (container) {
          // Scroll the container to its maximum height
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    onInput() {
      this.$emit('update-user-query', this.user_query);
    },
    submitSearch() {
      this.$emit('submit-search', true);
    },
    async getAIQueries() {
      this.loadingHistory = true;
      try {
        const response = await fetchAIQueries();
        this.userHistory = response.data.filter(ai_query => {
          const { id, threads, ai_response_title, query_name } = ai_query;
          return id && threads.length > 0 && (ai_response_title || query_name);
        });
      } catch (error) {
        //console.error("Error fetching queries:", error);
      } finally {
        this.loadingHistory = false;
      }
    },
    clearUserQuery() {
      this.user_query = "";
      this.$emit('update-user-query', "");
    },
    async analyseResults(messageIndex) {
      const message = this.selectedQueryMessages[messageIndex];
      if (!message || !message.querystring) return;

      this.analysisLoading = messageIndex;
      const encodedQuerystring = encodeURIComponent(message.querystring);
      
      try {
        const response = await fetchSearchQuery(
          message.message_text || "Analyse this query", // Use original query text or fallback
          this.formatDateToCustomString(new Date()),
          this.query_id,
          encodedQuerystring,
          message.id,
          true // analyse = true
        );

        // Update the current message with the analysis response
        this.$set(this.selectedQueryMessages, messageIndex, {
          ...message,
          system_response: response.summary,
          querystring: response.querystring,
          qry_description: response.query_description,
          is_help: /<a href="https:\/\/docs\.tendertrace\.com/.test(response.summary),
          created: new Date().toISOString(),
          analysis: response.analysis,
          id: response.message_id,
        });

      } catch (error) {
        // Update the current message with error response
        this.$set(this.selectedQueryMessages, messageIndex, {
          ...message,
          system_response: "Sorry, I couldn't analyze this query. Please try again.",
          errored: true,
          created: new Date().toISOString()
        });
        //console.error("Error analyzing query:", error);
      } finally {
        this.analysisLoading = null;
      }
    },
    async plainTextSearch(analyse) {
      if (this.user_query) {
        this.loading_query = true;
        let temp_uq = this.user_query;
        const timestamp = new Date().toISOString();
        this.selectedQueryMessages.push({
          id: 'user_' + Date.now(),
          message_type: 'user',
          message_text: this.user_query,
          created: timestamp
        });
        this.clearUserQuery();
        const encodedQuerystring = encodeURIComponent(this.querystring);
        try {
          const response = await fetchSearchQuery(
            temp_uq,
            this.formatDateToCustomString(new Date()),
            this.query_id,
            encodedQuerystring,
            analyse
          );
          this.selectedQuery = response.query_record;

          // Optimistically update the history. Check to see if an entry w/ the same ID exists before appending a new one.
          const existingHistoryEntryIdx = this.userHistory.findIndex(sQ => sQ.id === this.selectedQuery.id);
          if (existingHistoryEntryIdx >= 0)
            this.userHistory.splice(existingHistoryEntryIdx, 1, this.selectedQuery);
          else
            this.userHistory.splice(0, 0, this.selectedQuery);

          this.query_id = this.selectedQuery.id;
          const re = /<a href="https:\/\/docs\.tendertrace\.com/;
          this.selectedQueryMessages.push({
            id: response.message_id,
            message_type: 'system',
            system_response: response.summary,
            querystring: response.querystring,
            qry_description: response.query_description,
            is_help: re.test(response.summary),
            created: new Date().toISOString(),
            analysis: response.analysis
          });
        } catch (error) {
          this.selectedQueryMessages.push({
            id: 'system_' + Date.now(),
            message_type: 'system',
            system_response: "Sorry, I couldn't understand your request. Try rewording or expanding your query.",
            querystring: null,
            errored: true,
            created: new Date().toISOString(),
            analysis: null
          });
          //console.error("Error fetching search query:", error);
        } finally {
          this.loading_query = false;
        }
      }
    },
    onQuerySelect(selectedQuery) {
      if (selectedQuery) {
        const re = /<a href="https:\/\/docs\.tendertrace\.com/;
        this.selectedQueryMessages = selectedQuery.threads.map(q => {
          return {
            id: q.id,
            message_type: q.message_type,
            message_text: q.message_text,
            system_response: q.system_response,
            querystring: q.querystring,
            qry_description: q.query_description,
            is_help: re.test(q.system_response),
            created: q.created
          }
        });
        this.clearUserQuery();
        this.query_id = selectedQuery.id;
        this.querystring = null;
      }
    },
    onClear() {
      this.selectedQuery = null;
      this.selectedQueryMessages = [];
      this.user_query = "";
      this.query_id = null;
      var query = this.$route.query;
      query["viewIndex"] = 0;
      this.queryString = this.searchParamsQry;
    },
    queryStringToJson(queryString) {
      if (queryString.startsWith('?')) {
        queryString = queryString.substring(1);
      }
      const params = new URLSearchParams(queryString);
      const result = {};
      params.forEach((value, key) => {
        if (result[key]) {
          if (Array.isArray(result[key])) {
            result[key].push(value);
          } else {
            result[key] = [result[key], value];
          }
        } else {
          result[key] = value;
        }
      });
      return result;
    },
    formattedTimestamp(timestamp) {
      const date = new Date(timestamp);
      if (isNaN(date)) return "Invalid Date";
      const optionsTime = { hour: "numeric", minute: "numeric", hour12: true };
      const optionsDate = { year: "numeric", month: "short", day: "numeric" };
      return `${date.toLocaleTimeString(undefined, optionsTime)}, ${date.toLocaleDateString(undefined, optionsDate)}`;
    },
    formatDateToCustomString(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      const milliseconds = String(date.getMilliseconds()).padStart(3, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    },
  },
};
</script>

<style>
.system-message {
  background-color: #12253a;
  color: white;
  margin-right: auto;
  margin-left: 0;
  /* Removed offset */
  border-top-left-radius: 0;
  border-bottom-left-radius: 16px;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.5;
  max-width: 100%;
  word-wrap: break-word;
  margin-top: 14px;
  margin-bottom: 0;
}

.user-message {
  background-color: white;
  color: #12253a;
  margin-left: auto;
  margin-right: 0;
  /* Removed offset */
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 0;
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.5;
  max-width: 100%;
  word-wrap: break-word;
  border: 2px solid lightgrey;
  margin-top: 0;
  margin-bottom: 0;
}

.send-icon {
  cursor: pointer;
  margin-top: -5px;
}

.chat-bubble-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 14px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0;
  padding-bottom: 0;
}

.chat-bubble {
  max-width: 100%;
  padding: 16px;
  font-size: 15px;
  line-height: 1.5;
}

.message-text {
  white-space: pre-wrap;
}

.created-date {
  font-size: 10px;
  color: grey;
  margin-bottom: 4px;
}

.menu-item-text {
  font-size: 14px;
  white-space: normal;
  word-wrap: break-word;
}

.message-text a {
  color: rgb(255, 231, 10) !important;
  text-decoration: underline;
  word-break: break-word;
}

#wave {
  margin-bottom: 14px;
  margin-left: 8px;
}

#wave .dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 3px;
  background-color: #12253a;
  animation: wave 1.3s linear infinite;
}

div#wave .dot:nth-child(2) {
  animation-delay: -1.1s;
}

div#wave .dot:nth-child(3) {
  animation-delay: -0.9s;
}

@keyframes wave {

  0%,
  60%,
  100% {
    transform: initial;
  }

  30% {
    transform: translateY(-15px);
  }
}

.chat-inner-wrapper {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 24px;
}
</style>